class AfterSignupSurveyController {
  constructor(Authentication, PersonaCollection, $timeout, $scope) {
    'ngInject';

    Object.assign(this, { Authentication, PersonaCollection, $timeout, $scope });
  }

  $onInit() {
    this.user = null;
    this.init();
  }

  async init() {
    await this.Authentication.userLoaded;
    await this.PersonaCollection.personaCollectionLoaded;
    await this.$timeout(1000);

    this.user = this.Authentication.user;
    this.saveClientFlags = this.Authentication.saveClientFlags;

    this.$scope.$watch(
      'ctrl.Authentication.user.settings.clientFlags.canShowSurvey1',
      (newValue, oldValue) => {
        if (newValue && !oldValue) {
          this.user = { ...this.Authentication.user };
        }
      }
    );
  }

  get firstRun() {
    return this.Authentication.firstRun;
  }
}

export default {
  template: `
    <r-signup-survey ng-if="!!ctrl.user"
      user="ctrl.user"
      first-run="ctrl.firstRun"
      save-client-flags="ctrl.saveClientFlags(flags)">
    </r-signup-survey>
    `,
  controller: AfterSignupSurveyController,
  controllerAs: 'ctrl',
};
